import { render, staticRenderFns } from "./TestTaskCard.vue?vue&type=template&id=6d79bde0&v-if=test_task.id"
import script from "./TestTaskCard.vue?vue&type=script&lang=js"
export * from "./TestTaskCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports